import { render, staticRenderFns } from "./WhatIsDecast.vue?vue&type=template&id=b2556386&scoped=true&"
import script from "./WhatIsDecast.vue?vue&type=script&lang=js&"
export * from "./WhatIsDecast.vue?vue&type=script&lang=js&"
import style0 from "./WhatIsDecast.vue?vue&type=style&index=0&id=b2556386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2556386",
  null
  
)

export default component.exports